define(['app/modules/forms', 'app/modules/partners_invite', 'app/modules/utilities', 'vendor/jquery.dirtyforms.min.js'], function(Forms, PartnersInvite, Util) {
  var Partners = function () {};

  Partners.prototype.actionIndex = function() {
    var inviteForm = $('#invite-form');

    inviteForm.dirtyForms();

    var invitesList = $('.partners-invites-list');

    $('.invite-member').on('click', function (e) {
      if (Forms.ignoreDirtyInputs($('#partners-invite-email, #partners-invite-partner_name'))) {
        $('form:dirty').dirtyForms('setClean');
      } else {
        e.preventDefault();
      }
    });

    $('.save-company-settings').on('click', function (e) {
      e.preventDefault();
      Forms.submit($('#company-form'), '', function(result){Forms.showSuccess(result)});
    });

    $('.remove-partner').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (confirm("Are you sure that you want to delete the partner?")) {
        var el = $(e.currentTarget);
        var url = el.data('url');
        $.ajax({
          type: 'DELETE',
          url: url,
          success: function(result){
            el.closest('.company-partner-container').remove();
          },
          error: function(result) {
          }
        });
      }
    });

    $('.add-partners-invite').on('click', function (e) {
      e.preventDefault();
      PartnersInvite.add();
    });

    invitesList.on('click', '.remove-partners-invite', function (e) {
      e.preventDefault();
      PartnersInvite.remove($(this));
    });

    invitesList.on('click', '.edit-partners-invite', function (e) {
      e.preventDefault();
      PartnersInvite.edit($(this));
    });

    invitesList.on('click', '.apply-partners-invite', function (e) {
      e.preventDefault();
      PartnersInvite.apply($(this));
    });

    invitesList.on('click', '.cancel-partners-invite', function (e) {
      e.preventDefault();
      PartnersInvite.cancel($(this));
    });

    inviteForm.on('submit', function(e){
      e.preventDefault();
      for (instance in CKEDITOR.instances) {
        CKEDITOR.instances[instance].updateElement();
      }
      Forms.submit($(this), '', function(){document.location.reload()});
    });

    Util.applyClipboard('.btn-copy', 'Copy to clipboard');
  };

  return Partners;
});
